/* PHONE_FIRST × DONATION — thin route shell (Phase 4 §4.1). */

import { FeatureFlagRouteGuard } from '../entitlements/FeatureFlagRouteGuard.js';
import { usePhoneFirstDonationJourney } from './hooks/usePhoneFirstDonationJourney.js';
import { PhoneFirstDonationScreenView } from './components/phone-first-donation/PhoneFirstDonationScreenView.js';

export function PhoneFirstDonationJourney(): JSX.Element | null {
  return (
    <FeatureFlagRouteGuard requires={{ master: true, anyOf: ['donate'] }}>
      <PhoneFirstDonationScreenView {...usePhoneFirstDonationJourney()} />
    </FeatureFlagRouteGuard>
  );
}
